import * as ActionTypes from './actionType.js';


const reducerMap = {
    [ActionTypes.GET_TASK_LIST_REQUEST]: (state) => {
        return Object.assign({}, state, {
            status: true,
            error: ''
        });
    },
    [ActionTypes.GET_TASK_LIST_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            status: false,...payload
        });
    },
    [ActionTypes.GET_TASK_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            status: false,
            error: payload
        });
    },
    [ActionTypes.SET_MISSION_LIST_CURRENT]: (state, payload) => {//设置任务阶段选中状态
        return Object.assign({}, state, {
            current: payload
        });
    },

}
export const INITIALIZE_STATE = {
    list:[],
    current:'pre_assign',
}
export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/reducer.js